require("./tween_to_xy.js");
require("./tween_to_stretch.js");
require("./tween_to_size.js");
require("./tween_to_skew.js");
require("./tween_to_object.js");
require("./tween_to_property.js");
require("./tween_to_global_variable.js");